import {useNavigation, useRoute} from '@react-navigation/native';
import {Button} from '@ui-kitten/components';
import React, {useEffect, useState} from 'react';
import {StyleSheet} from 'react-native';
import {getTeacherSchedules} from '../../apis';
import {AUTHENTICATED_ROUTES} from '../../navigation/constants';
import {px, useAsync, useIsLandscape} from '../../utils';
import {AppLoadingIndicator, Page, TimeTable, TitleRow} from '../components';
import {renderIf} from '../../utils/Utils';
import {PaymentErrorModal} from '../Payment/PaymentErrorModal';

const SelectTimeTable = ({landscapeParams, setLandscapeRouteAndParams}) => {
  const navigation = useNavigation();
  const isLandscape = useIsLandscape();
  const {params} = useRoute();
  const {
    selectedStudent,
    selectedSubjects,
    totalPrice,
    unitPrice,
    studentGradeId,
    packageId,
    iosProductId,
    gradeId,
    packageType,
    packageTitle,
    monthNumber,
  } = landscapeParams || params;

  const [selectedTimeTable, setSelectedTimeTable] = useState([]);

  const {loading: timetableLoading, value: timeTableData} = useAsync(
    () =>
      getTeacherSchedules({
        gradeIds: [studentGradeId],
        subjectIds: selectedSubjects.map(({value}) => value),
      }),
    [studentGradeId, selectedSubjects],
  );

  useEffect(() => {
    // reset selectedTimeTable,
    // because it's no more valid when new timeTableData arrives
    setSelectedTimeTable([]);
  }, [timeTableData]);

  const onTimeTableCardSelect = (selectedItem) => {
    const itemSelectedBefore = selectedTimeTable.find(
      (oldItem) => oldItem.scheduleId === selectedItem.scheduleId,
    );

    // remove, if it was already selected
    if (itemSelectedBefore) {
      const filteredList = selectedTimeTable.filter(
        (oldItem) => oldItem.scheduleId !== selectedItem.scheduleId,
      );
      setSelectedTimeTable(filteredList);
      return;
    }

    const sameSubjectSelectedBefore = selectedTimeTable.find(
      (oldItem) => oldItem.subjectId === selectedItem.subjectId,
    );

    // only one subject in a week is selectable.
    // we replace the new with the old one
    if (sameSubjectSelectedBefore) {
      const filteredList = selectedTimeTable.filter(
        (oldItem) => oldItem.subjectId !== selectedItem.subjectId,
      );
      setSelectedTimeTable([...filteredList, selectedItem]);
      return;
    }

    // add, if it wasn't selected before
    setSelectedTimeTable((cards) => [...cards, selectedItem]);
  };

  const isSomeSubjectsNotSelected = selectedSubjects?.some(
    (subject) =>
      !selectedTimeTable.find(
        (timetable) => subject.id === timetable.subjectId,
      ),
  );
  var isPaymentError = false;
  if (selectedStudent && selectedStudent.gradeId) {
    //console.log('Process');
  } else {
    isPaymentError = true;
  }

  return (
    <Page
      header={{
        title: 'Timetable',
        showBackAction: true,
        onModalBackPressed() {
          setLandscapeRouteAndParams(
            AUTHENTICATED_ROUTES.configurePackage.path,
            undefined,
          );
        },
      }}
      useModalView={isLandscape}>
      {renderIf(isPaymentError, <PaymentErrorModal />)}
      <TitleRow title="Please select your timetable" type="secondary" />
      {timetableLoading ? (
        <AppLoadingIndicator />
      ) : (
        <TimeTable
          hideTitle
          data={timeTableData}
          containerStyle={styles.timeTable}
          selectedCards={selectedTimeTable}
          onCardSelect={onTimeTableCardSelect}
        />
      )}
      <Button
        disabled={isSomeSubjectsNotSelected}
        style={styles.submitButton}
        onPress={() => {
          const paramsToSet = {
            iosProductId,
            packageTitle,
            packageId,
            gradeId,
            packageType,
            totalPrice,
            unitPrice,
            selectedStudent,
            selectedSubjects,
            selectedTimeTable,
            monthNumber,
          };
          const routeToSet = AUTHENTICATED_ROUTES.packagePurchaseSummary.path;

          if (isLandscape) {
            setLandscapeRouteAndParams(routeToSet, paramsToSet);
          } else {
            navigation.navigate(routeToSet, paramsToSet);
          }
        }}>
        {'View Summary'}
      </Button>
    </Page>
  );
};

const styles = StyleSheet.create({
  marginTop: {
    marginTop: px(30),
  },
  submitButton: {
    margin: px(17),
    marginTop: px(30),
  },
  timeTable: {
    width: '100%',
  },
});

export default SelectTimeTable;
